import { useEffect, useState, useCallback } from "react";
import {
  Modal,
  IconButton,
  TextField,
  Button,
  Avatar,
  InputAdornment,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Stack,
  Typography,
  Box,
  Card,
  CircularProgress,
  ListItemButton
} from "@mui/material";
import { Close, Search } from "@mui/icons-material";
import PromptModal from "./PromptModal";
import UseDebounce from "./UseDebounce";
import { INVITEFRIENDSBYEMAIL, SAVECONTACTEVENT, SEARCHUSERSMEMBERS } from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import { Getrequestcall } from "../../request/Getrequest";
import { useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import ReferralModal from "./ReferralModal";
import Loader from "../../common/Loader";
import { useNavigate } from "react-router-dom";
import { English } from "../../constant/EnglishFallback";

function AddContact({ isOpen, onClose, setNewContactModalOpen, from, setShouldCall }) {
  const { multiLanguageData } = useSelector((state) => state?.main);
  const LanguageData = multiLanguageData?.BuilderNetwork || {};
  const {
    TEXT_CANT_FIND_SOMEONE = English.BuilderNetwork.TEXT_CANT_FIND_SOMEONE,
    TEXT_INVITE_THEM = English.BuilderNetwork.TEXT_INVITE_THEM,
    TEXT_MASSAGE = English.BuilderNetwork.TEXT_MASSAGE,
    TEXT_COPY_LINK = English.BuilderNetwork.TEXT_COPY_LINK,
    TEXT_SHARE = English.BuilderNetwork.TEXT_SHARE,
    TEXT_ADD_CONTACT = English.BuilderNetwork.TEXT_ADD_CONTACT,
    TEXT_SEARCH_PEOPLE = English.BuilderNetwork.TEXT_SEARCH_PEOPLE,
    TEXT_NO_DATA = English.BuilderNetwork.TEXT_NO_DATA,
    TEXT_CONNECT = English.BuilderNetwork.TEXT_CONNECT,
    TEXT_REQUEST_SEND = English.BuilderNetwork.TEXT_REQUEST_SEND,
    TEXT_ACCEPT = English.BuilderNetwork.TEXT_ACCEPT,
    TEXT_MESSAGES = English.BuilderNetwork.TEXT_MESSAGES,
    TEXT_CANCEL_REQUEST = English.BuilderNetwork.TEXT_CANCEL_REQUEST,
    TEXT_CONFIMATION = English.BuilderNetwork.TEXT_CONFIMATION,
    TEXT_CANCEL = English.BuilderNetwork.TEXT_CANCEL,
    TEXT_OK = English.BuilderNetwork.TEXT_OK
  } = LanguageData || {};

  const [newEmail, setNewEmail] = useState("");
  const [searchData, setSearchData] = useState([]);
  const [cancelItem, setCancelItem] = useState({});
  const [alertModalOpen, setAlertModalOpen] = useState(false);
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [qrCodeValue, setQrCodeValue] = useState(null);
  const { loginData } = useSelector((state) => state?.main);
  const [isLoading, setIsLoading] = useState(false);
  const debouncedEmail = UseDebounce(newEmail, 500);
  const [loadingButtons, setLoadingButtons] = useState({});
  const [isSearchStarted, setIsSearchStarted] = useState(false);

  const navigate = useNavigate();
  useEffect(() => {
    setQrCodeValueBasedOnDb();
  }, []);

  const setQrCodeValueBasedOnDb = useCallback(async () => {
    const value = `${import.meta.env.REACT_APP_WEB_USER}/refer/${loginData?.userInformation?.UserId}`;
    setQrCodeValue(value);
  }, []);

  useEffect(() => {
    if (debouncedEmail) {
      setIsSearchStarted(true); // Start search when there's input
      fetchSearchResults(debouncedEmail);
    } else {
      setSearchData([]); // Clear results if input is empty
      setIsSearchStarted(false); // Reset search flag when cleared
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedEmail]);
  const fetchSearchResults = useCallback(async (searchValue) => {
    try {
      const obj = {
        CurUserId: loginData?.userInformation?.UserId,
        SearchString: searchValue.trim()
      };
      setIsLoading(true);

      // const response = await Postrequestcall(SEARCH_USERS_MEMBERS_V2, obj, loginData?.accessToken);
      let getResponse = await Getrequestcall(
        `${SEARCHUSERSMEMBERS}/${loginData?.userInformation?.UserId}/${0}/${searchValue.trim()}`,
        loginData?.accessToken
      );
      const filteredArray = getResponse?.data?.data?.filter((obj) => obj.contactStatus !== "me");
      setSearchData(filteredArray);
      setIsLoading(false);
    } catch (error) {
      console.log("fetchSearchResults-> Error When Searching Users Member: ", error);
    }
  }, []);

  const handleChangeEmail = (event) => {
    if (event != "") {
      setNewEmail(event);
    } else {
      clearInput();
    }
  };

  const handleCancelRequest = async (contact) => {
    try {
      setLoadingButtons((prev) => ({ ...prev, [contact.userId]: true })); // Set loading for this user
      const getObject = {
        Id: 0,
        UserId: loginData?.userInformation?.UserId,
        ContactEmail: cancelItem.userEmail,
        EventStatusId: 3, // eventStatusId 5 = delete
        ModifiedBy: loginData?.userInformation?.UserId
      };
      await Postrequestcall(SAVECONTACTEVENT, getObject, loginData?.accessToken);
      updateSearchData(cancelItem.userId, "No");
      clearInput();
      setAlertModalOpen(false);
    } catch (error) {
      console.log("handleCancelRequest-> Error When Canceling Request: ", error);
    } finally {
      setAlertModalOpen(false);
      setLoadingButtons((prev) => ({ ...prev, [contact.userId]: false })); // Remove loading
    }
  };

  const handleAddContact = async (contact) => {
    try {
      setLoadingButtons((prev) => ({ ...prev, [contact.userId]: true })); // Set loading for this user
      let obj = {
        UserId: loginData?.userInformation?.UserId,
        FriendsEmails: contact.userEmail,
        Notification: {
          ActionUrl: `${import.meta.env.REACT_APP_CONTACTPROFILE}${Number(
            loginData?.userInformation?.UserId
          )}`,
          title: "Connect Request",
          Body: "has requested to Connect you."
        }
      };
      const response = await Postrequestcall(INVITEFRIENDSBYEMAIL, obj, loginData?.accessToken);

      if (response?.data?.data === "Connect Request Send") {
        updateSearchData(contact.userId, "Request Sent");
      }
    } catch (error) {
      console.log("handleAddContact-> Error When Adding Contact: ", error);
    } finally {
      setLoadingButtons((prev) => ({ ...prev, [contact.userId]: false })); // Remove loading
    }
  };

  const handleAcceptRequest = async (contact) => {
    try {
      setLoadingButtons((prev) => ({ ...prev, [contact.userId]: true })); // Set loading for this user
      const getObject = {
        Id: 0,
        UserId: loginData?.userInformation?.UserId,
        ContactEmail: contact.userEmail,
        EventStatusId: 2,
        ModifiedBy: contact?.userId
      };
      await Postrequestcall(SAVECONTACTEVENT, getObject, loginData?.accessToken);
      updateSearchData(contact.userId, "Yes");
      if (from === "Profile") {
        setShouldCall(true);
      }
    } catch (error) {
      console.log("handleAcceptRequest-> Error When Accepting Request: ", error);
    } finally {
      setLoadingButtons((prev) => ({ ...prev, [contact.userId]: false })); // Remove loading
    }
  };

  const clearInput = () => {
    setNewEmail("");
    setSearchData([]);
  };

  const updateSearchData = (userId, status) => {
    setSearchData((prevData) =>
      prevData?.map((item) => (item?.userId === userId ? { ...item, contactStatus: status } : item))
    );
  };

  return (
    <>
      <Modal open={isOpen}>
        <Box className="user-modal-responsive">
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 1
            }}>
            <Typography variant="h5">{TEXT_ADD_CONTACT}</Typography>
            <CloseIcon
              style={{ color: "#083DB8", cursor: "pointer" }}
              onClick={() => {
                onClose();
                clearInput();
              }}
            />
          </Box>
          <TextField
            fullWidth
            size="small"
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
                endAdornment: newEmail && (
                  <InputAdornment position="end">
                    <IconButton onClick={clearInput}>
                      <Close />
                    </IconButton>
                  </InputAdornment>
                )
              }
            }}
            value={newEmail}
            variant="outlined"
            onChange={(e) => {
              let inputValue = e.target.value;
              inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
              handleChangeEmail(inputValue);
            }}
            placeholder={TEXT_SEARCH_PEOPLE}
            autoComplete="off"
          />

          <Box
            sx={{
              marginTop: "10px",
              paddingBottom: "10px",
              scrollbarWidth: "none",
              height: "450px",
              overflow: "auto"
            }}>
            {isSearchStarted ? (
              isLoading ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    height: 440
                  }}>
                  <Loader />
                </Box>
              ) : searchData?.length > 0 ? (
                <List disablePadding>
                  <Stack gap={1}>
                    {searchData.map((item, index) => (
                      <Card key={index} className="pagelist-content" sx={{ marginTop: 0 }}>
                        <ListItem
                          sx={{ m: 0 }}
                          key={index}
                          disablePadding
                          secondaryAction={
                            item?.contactStatus === "No" ? (
                              <Button
                                sx={{ backgroundColor: "#0826b8" }}
                                color="primary"
                                variant="contained"
                                onClick={() => handleAddContact(item)}
                                disabled={loadingButtons[item?.userId]}>
                                {loadingButtons[item?.userId] ? (
                                  <CircularProgress size={20} color="inherit" />
                                ) : (
                                  TEXT_CONNECT
                                )}
                              </Button>
                            ) : item?.contactStatus === "Request Sent" ? (
                              <Button
                                sx={{ color: "#0826b8" }}
                                variant="outlined"
                                onClick={() => {
                                  setAlertModalOpen(true);
                                  setCancelItem(item);
                                  onClose();
                                }}
                                disabled={loadingButtons[item?.userId]}>
                                {loadingButtons[item?.userId] ? (
                                  <CircularProgress size={20} color="inherit" />
                                ) : (
                                  TEXT_REQUEST_SEND
                                )}
                              </Button>
                            ) : item?.contactStatus === "Awaiting response" ? (
                              <Button
                                sx={{ backgroundColor: "#0826b8" }}
                                color="primary"
                                variant="contained"
                                onClick={() => handleAcceptRequest(item)}
                                disabled={loadingButtons[item?.userId]}>
                                {loadingButtons[item?.userId] ? (
                                  <CircularProgress size={20} color="inherit" />
                                ) : (
                                  TEXT_ACCEPT
                                )}
                              </Button>
                            ) : (
                              <Button
                                sx={{ backgroundColor: "#0826b8" }}
                                color="primary"
                                variant="contained">
                                {TEXT_MESSAGES}
                              </Button>
                            )
                          }>
                          <ListItemButton
                            alignItems="flex-start"
                            sx={{ m: 0 }}
                            onClick={() => navigate(`/${item?.userId}`)}>
                            <ListItemAvatar>
                              <Avatar alt="contact-PictureUrl" src={item?.pictureUrl} />
                            </ListItemAvatar>

                            <ListItemText
                              primary={`${item?.firstName} ${item?.lastName}`}
                              secondary={item?.tradeName}
                            />
                          </ListItemButton>
                        </ListItem>
                      </Card>
                    ))}
                  </Stack>
                </List>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    height: 440
                  }}>
                  <Typography variant="h4">{TEXT_NO_DATA}</Typography>
                </Box>
              )
            ) : null}
          </Box>
          <div style={{ paddingTop: "5px" }}>
            <Typography
              style={{
                fontSize: "14px",
                color: "gray",
                display: "flex",
                justifyContent: "center"
              }}>
              {TEXT_CANT_FIND_SOMEONE}
              <span
                style={{
                  color: "#0826b8",
                  fontWeight: "600",
                  cursor: "pointer",
                  marginLeft: "5px"
                }}
                onClick={() => {
                  setShowInviteModal(true);
                  onClose();
                  clearInput();
                }}>
                {TEXT_INVITE_THEM}
              </span>
            </Typography>
          </div>
        </Box>
      </Modal>

      <ReferralModal
        open={showInviteModal}
        TEXT_MASSAGE={TEXT_MASSAGE}
        TEXT_SHARE={TEXT_SHARE}
        TEXT_COPY_LINK={TEXT_COPY_LINK}
        onClose={() => {
          setShowInviteModal(false);
          onClose();
          clearInput();
        }}
      />

      <PromptModal
        isOpen={alertModalOpen}
        title={TEXT_CANCEL_REQUEST}
        desc={TEXT_CONFIMATION}
        redButtonText={TEXT_CANCEL}
        blueButtonText={TEXT_OK}
        onRedButtonClick={() => {
          setAlertModalOpen(false);
          setNewContactModalOpen(true);
          setCancelItem({});
        }}
        onBlueButtonClick={handleCancelRequest}
      />
    </>
  );
}

export default AddContact;
